module.exports = "/assets/rwp_share.png?JA7qjZX";